/**
 * 优惠券发放记录
 */
import { COUPONSENDLIST } from '../types';

export default {
    name: `${COUPONSENDLIST}`,
    path: '/couponSendList',
    component: () => import(/* webpackChunkName: 'couponSendList' */ '@/views/couponSendList/'),
    redirect: { name: `${COUPONSENDLIST}Index` },
    meta: {
        title: '优惠券发放记录',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COUPONSENDLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'couponSendList' */ '@/views/couponSendList/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${COUPONSENDLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'couponSendList' */ '@/views/couponSendList/detail/Detail.vue'),
        },
    ],
};
